module.exports = {
  answerTimeLimit: 16,
  scoreLimit: 10,
  delayAfterUnansweredQuestion: 3,
  delayAfterAnsweredQuestion: 2.2,
  additionalAnswerWaitWindow: 2.1,
};
